import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import AIService from '../../services/aiService';
import { JournalType } from './journalHelper';

const NewEntityButton = (props) => {
    const [disabled, setDisabled] = useState(false);
    const ENTITY_QUESTION = 'Generate a name, race, class, stats, background, and physical_description for a new entity in a fantasy role-playing game in JSON format.  Escape single and double quote marks.  Do not use blockcode.';

    const newEntity = () => {
        if(!disabled) {
            setDisabled(true);
            AIService.getCompletion(ENTITY_QUESTION, 
                (data) => { 
                    console.info(data)
                    let tempEntry = data;
                    tempEntry['icon'] = JournalType.ENTITY.icon;
                    tempEntry['type'] = JournalType.ENTITY.type;
                    tempEntry['notes'] = [{ role: 'assistant', content: data.background }, { role: 'assistant', content: data.physical_description }];
                    tempEntry['transcript'] = [
                        { role: 'user', content: ENTITY_QUESTION },
                        { role: 'assistant', content: JSON.stringify(data) }
                    ]
                    props.addEntry(tempEntry)
                    setDisabled(false);
                },
                (error) => {
                    console.info(error);
                    alert('The GM had his mouth full of Doritos and his response was unintelligible.');
                    setDisabled(false);
                });
        }
    }

    return <Button variant="light" onClick={newEntity} title="New Entity" disabled={disabled}>{disabled ? '🚫' : '👤'}</Button>
}

export default NewEntityButton;